import { render, staticRenderFns } from "./pregunta-responder-predefinidas.vue?vue&type=template&id=2c08f550&scoped=true&"
import script from "./pregunta-responder-predefinidas.vue?vue&type=script&lang=ts&"
export * from "./pregunta-responder-predefinidas.vue?vue&type=script&lang=ts&"
import style0 from "./pregunta-responder-predefinidas.vue?vue&type=style&index=0&id=2c08f550&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c08f550",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VList,VListItem,VListItemGroup,VRow,VSpacer})
